import { changeLanguage } from "i18next";
import * as Yup from "yup";

export const ApplicationValidation = Yup.object().shape({
  contactName: Yup.string().min(1, "Too Short!").required("Required"),
  contactEmail: Yup.string().matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/),
  contactPhone: Yup.string()
    .matches(/^[5|7][0-9]{8}$/)
    .required("Required"),
  companyCode: Yup.string().min(1, "Too Short!").required("Required"),

  companyName: Yup.string(),

  // activityCode: Yup.object().required("Required"),
  // regionCode: Yup.object().required("Required"),
  companyWebSite: Yup.string(),
  agree: Yup.boolean().test({
    test: (value) => !!value,
  }),
  posTerminalType: Yup.mixed().when(["productTypes"], {
    is: (productTypes) => productTypes.includes("POS"),
    then: (ApplicationValidation) => ApplicationValidation.required(),
    otherwise: (ApplicationValidation) => ApplicationValidation.nullable(),
  }),
  regionCode: Yup.mixed().when(["productTypes"], {
    is: (productTypes) => productTypes.includes("POS"),
    then: (ApplicationValidation) => ApplicationValidation.required(),
    otherwise: (ApplicationValidation) => ApplicationValidation.nullable(),
  }),
});
